import { DateTime } from 'luxon';

export const toDenominatorDateFormat = (date: Date, yearMonthOnly?: boolean): string => {
	return DateTime.fromJSDate(date).toFormat(yearMonthOnly ? 'yyyy MM' : 'yyyy MM dd'); // ! be aware, Formats are different from Dayjs.
};
